import { TableRow, TableCell } from '@client/components/ui/table';

interface AdvisorUsageTableSkeletonProps {
  rowCount?: number;
}

export function AdvisorUsageTableSkeleton({ rowCount = 5 }: AdvisorUsageTableSkeletonProps) {
  return (
    <>
      {Array.from({ length: rowCount }).map((_, idx) => (
        <TableRow key={`skeleton-${idx}`}>
          <TableCell>
            <div className="flex items-center gap-3">
              <div className="h-8 w-8 animate-pulse rounded-full bg-gray-100" />
              <div className="h-4 w-32 animate-pulse rounded bg-gray-100" />
            </div>
          </TableCell>
          <TableCell>
            <div className="h-4 w-24 animate-pulse rounded bg-gray-100" />
          </TableCell>
          <TableCell>
            <div className="h-4 w-40 animate-pulse rounded bg-gray-100" />
          </TableCell>
          <TableCell>
            <div className="h-4 w-16 animate-pulse rounded bg-gray-100" />
          </TableCell>
          <TableCell>
            <div className="h-4 w-12 animate-pulse rounded bg-gray-100" />
          </TableCell>
          <TableCell className="text-right">
            <div className="ml-auto h-4 w-12 animate-pulse rounded bg-gray-100" />
          </TableCell>
        </TableRow>
      ))}
    </>
  );
}
